import { createContext } from 'react'

import { createAuctionDetailAuthenticatorStore } from '../store/createStore'

export const AuctionDetailAuthenticatorStoreCotnext = createContext<
  ReturnType<typeof createAuctionDetailAuthenticatorStore> | undefined
>(undefined)
